import { encodeString, decodeString } from 'use-query-params';

export const EnumStringParam = (allowed: string[], defaultValue?: string) => ({
  encode: encodeString,
  decode: (s: string | string[] | null | undefined) => {
    const decoded = decodeString(s);
    return allowed.find(a => a === decoded) ?? defaultValue;
  }
});
